import React from 'react';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../lib/i18n';

const LANGS = [
  { code: 'nl', flag: '🇳🇱' },
  { code: 'en', flag: '🇬🇧' },
];

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.language;

  return (
    <div style={{ display: 'flex', gap: 2 }}>
      {LANGS.map(({ code, flag }) => (
        <button
          key={code}
          onClick={() => setLanguage(code)}
          title={t(`lang.${code}`)}
          style={{
            background: current === code ? 'var(--selection-tint)' : 'transparent',
            border: current === code ? '1px solid var(--selection)' : '1px solid #e2e8f0',
            borderRadius: 4,
            cursor: 'pointer',
            padding: '2px 8px',
            fontSize: 16,
            lineHeight: 1.4,
            color: '#374151',
            transition: 'background 0.15s, border-color 0.15s',
          }}
        >
          {flag}
        </button>
      ))}
    </div>
  );
}
